// Mirrors Tenant::FRENCH_LANGUAGE / Tenant::SPANISH_LANGUAGE — the values arrive from
// Tenant#catalog_translation_languages via the translationLanguages prop.
export const TRANSLATION_LANGUAGES = {
    ES: 'es',
    FR: 'fr'
};
